import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SocialMediaLinksService } from "src/app/Services/SocialMediaLinkService/social-media-links.service";
import { ISocialMediaLinks } from "src/app/Models/Interface/SocialMediaLinks/social-media-links";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  year = new Date().getFullYear();
  socialMediaLinks: ISocialMediaLinks[] = [];

  constructor(
    public router: Router,
    private socialMediaLinksService: SocialMediaLinksService
  ) {
    this.getSocialMediaLinks();
  }

  ngOnInit(): void {}

  getSocialMediaLinks(): void {
    this.socialMediaLinksService.getSocialMediaLinks().subscribe((res) => {
      this.socialMediaLinks = res;
      localStorage.setItem(
        "socialMediaLinks",
        JSON.stringify(this.socialMediaLinks)
      );
    });
  }
}
